<template>
    <div>
    <!-- <router-view v-slot="{ Component }">
        <transition name="fade-slide" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view> -->

    <router-view />

    </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
:root {
    --primary: #61C7F2;
    --secondary: #F7A51B;
    --light: #EFFDF5;
    --dark: #2B3940;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(15px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>
